<template>
  <div class="container" v-if="isVisible()">
    <form @submit.prevent="submit">
      <div class="card">
        <div class="card-header">
          <h1 class="text-center">Confirm and Submit</h1>
        </div>

        <div class="card-body">
          <div v-if="showFeeAgreement()">
            <h3>AGENT-CLIENT DIRECT PAY FEE AGREEMENT</h3>

            This AGENT-CLIENT DIRECT PAY FEE AGREEMENT (Agreement) is entered into by {{ getData().claimant.person.firstName }} {{ getData().claimant.person.middleName }}  {{getData().claimant.person.lastName}} 
            (Client), and Carmella Nicole George, VA Accredited Claims Agent (Agent).

            <ol>
                <li>CONDITIONS. This Agreement will not take effect and Agent will have no obligation to provide legal services, until Client returns a signed copy of this Agreement.</li>

                <li>SCOPE AND DUTIES. Client hires Agent to provide legal services in connection with all proceedings for benefits before the U.S. Department of Veterans Affairs. Agent shall take reasonable steps to keep Client informed of progress and to respond to Client’s inquiries. Client shall be truthful with Agent, cooperate and communicate with Agent, keep Agent informed of developments, abide by this Agreement, pay Agent’s bills on time, and keep Agent advised of Client’s address, telephone number and whereabouts.</li>

                <li>CONTINGENT FEE/DIRECT PAY FEE AGREEMENT. Client agrees to pay a fee equal to 20 percent of the total amount of any past due benefits awarded on the basis of the
            Client’s claim with the U.S. Department of Veterans Affairs. It is understood that this contingent fee is to be paid by the VA directly to the Agent from any past due benefits awarded on the basis of the Client’s claim. However, Client remains liable for the amount of the contingent fee of 20 percent of any past due benefits awarded on the basis of the Client’s claim until and unless the fee is paid to the Agent by the VA, and Client agrees to pay said contingent fee directly to Agent in the event the VA fails to do so.</li>

                <li>COSTS AND EXPENSES. In addition to the contingent fee, Client shall reimburse Agent for all costs and expenses associated with the case. Agent will advance all costs and will be reimbursed only if a retroactive award is made. Client understands that payment of costs is in addition to the contingent fee. Client authorizes Agent to hire experts. Agent agrees to obtain Client’s consent before retaining any outside experts.</li>

                <li>DISCHARGE AND WITHDRAWAL. Client may discharge Agent at any time. Agent may withdraw with Client’s consent or for good cause. Good cause includes Client’s breach of this Agreement, Client’s refusal to cooperate or communicate with Agent or to follow Agent’s advice on a material matter or any other fact or circumstance that would render Agent’s continuing representation unlawful or unethical.</li>


                <li>DISCLAIMER OF GUARANTEE. Nothing in this Agreement and nothing in Agent’s statements to Client will be construed as a promise or guarantee about the outcome of Client’s matter. Agent makes no such promises or guarantees.</li>
            </ol>
            <br>
            <p>By clicking "Submit" below, I certify that I have read and understand the terms of this Agreement. I agree to abide by the terms of this Agreement. You will receive a copy of this agreement as a PDF. I understand that a copy of this Agreement will be filed with the appropriate officials at the U.S. Department of Veterans Affairs.</p>
          </div>

          <p style='text-align: center'>Please confirm intake information before submitting. Click on a field if the information is wrong.</p>          
          
          <table class="table table-hover">
            <tbody>
              <caption>Your Information</caption>           
              <ConfirmRow goto="veteranRelationship" name="Veteran Relationship">
                {{ veteranRelationship() }} 
              </ConfirmRow>
              <ConfirmRow goto="claimantName" name="Name">
                {{ getData().claimant.person.firstName }} {{ getData().claimant.person.middleName }}  {{getData().claimant.person.lastName}} 
              </ConfirmRow>
              <ConfirmRow goto="claimantBirthDay" name="Birthday">
                {{ epochToDate(getData().claimant.person.birthDay) }} 
              </ConfirmRow>
              <ConfirmRow goto="claimantBirthDay" name="Place of Birth">
                {{ getData().claimant.person.placeOfBirth }} 
              </ConfirmRow>
              <ConfirmRow goto="claimantSSN" name="SSN">
                {{ getData().claimant.person.SSN }} 
              </ConfirmRow>
              <ConfirmRow goto="claimantVAFileNumber" name="VA File Number">
                {{ getData().claimant.person.vaFileNumber }} 
              </ConfirmRow>
              <ConfirmRow goto="claimantSex" name="Gender">
                {{ getData().claimant.person.sex }} 
              </ConfirmRow> 
              <ConfirmRow goto="claimantEmail" name="Email">
                {{ getData().claimant.person.email }} 
              </ConfirmRow>                   
              <ConfirmRow goto="claimantPhone" name="Phone Number">
                {{ getData().claimant.person.phoneNumber }} 
              </ConfirmRow>
              <ConfirmRow goto="claimantPhone" name="Mobile Number">
                {{ getData().claimant.person.cellPhoneNumber }} 
              </ConfirmRow>   
              <ConfirmRow goto="claimantAddress" name="Address">
                {{ getData().claimant.person.street }} 
                {{ getData().claimant.person.unit }},
                {{ getData().claimant.person.city }},
                {{ getData().claimant.person.state }}
                {{ getData().claimant.person.zipCode }}                      
              </ConfirmRow>
              <ConfirmRow goto="claimantEmergencyContact" name="Emergency Contact Name:">
                {{ getData().claimant.person.emergencyContactName}}                    
              </ConfirmRow> 
              <ConfirmRow goto="claimantEmergencyContact" name="Emergency Contact Phone:">
                {{ getData().claimant.person.emergencyContactPhone}}                    
              </ConfirmRow>
              <ConfirmRow goto="claimantEmergencyContact" name="Emergency Contact Address:">
                {{ getData().claimant.person.emergencyContactAddress}}                    
              </ConfirmRow>                                                                                                                                                                                                                                                                                                                         
            </tbody>
          </table>
          <div v-if="veteranRelationship() !== 'Self'">
            <table class="table table-hover">
              <tbody>
                <caption>Veteran Information</caption>
                <ConfirmRow goto="veteranName" name="Name">
                  {{ getData().veteran.person.firstName }} {{ getData().veteran.person.middleName }}  {{getData().veteran.person.lastName}} 
                </ConfirmRow>
                <ConfirmRow goto="veteranBirthDay" name="Birthday">
                  {{ epochToDate(getData().veteran.person.birthDay) }} 
                </ConfirmRow>
                <ConfirmRow goto="veteranBirthDay" name="Place of Birth">
                  {{ getData().veteran.person.placeOfBirth }} 
                </ConfirmRow>
                <ConfirmRow goto="veteranDeathDay" name="Date of Death">
                  {{ epochToDate(getData().veteran.person.deathDay) }} 
                </ConfirmRow>                
                <ConfirmRow goto="veteranSSN" name="SSN">
                  {{ getData().veteran.person.SSN }} 
                </ConfirmRow>
                <ConfirmRow goto="veteranVAFileNumber" name="VA File Number">
                  {{ getData().veteran.person.vaFileNumber }} 
                </ConfirmRow>
                <ConfirmRow goto="veteranSex" name="Gender">
                  {{ getData().veteran.person.sex }} 
                </ConfirmRow> 
                <ConfirmRow goto="veteranEmail" name="Email">
                  {{ getData().veteran.person.email }} 
                </ConfirmRow>                   
                <ConfirmRow goto="veteranPhone" name="Phone Number">
                  {{ getData().veteran.person.phoneNumber }} 
                </ConfirmRow>
                <ConfirmRow goto="veteranPhone" name="Mobile Number">
                  {{ getData().veteran.person.cellPhoneNumber }} 
                </ConfirmRow>   
                <ConfirmRow goto="veteranAddress" name="Address">
                  {{ getData().veteran.person.street }} 
                  {{ getData().veteran.person.unit }},
                  {{ getData().veteran.person.city }},
                  {{ getData().veteran.person.state }}
                  {{ getData().veteran.person.zipCode }}                      
                </ConfirmRow>
                <ConfirmRow goto="veteranEmergencyContact" name="Emergency Contact Name:">
                  {{ getData().veteran.person.emergencyContactName}}                    
                </ConfirmRow> 
                <ConfirmRow goto="veteranEmergencyContact" name="Emergency Contact Phone:">
                  {{ getData().veteran.person.emergencyContactPhone}}                    
                </ConfirmRow>
                <ConfirmRow goto="veteranEmergencyContact" name="Emergency Contact Address:">
                  {{ getData().veteran.person.emergencyContactAddress}}                    
                </ConfirmRow>                                                                                                                                                                                                                                                                                                                         
              </tbody>
            </table>
          </div>
          <table class="table table-hover">
            <tbody>
              <caption>Service Information</caption>
              <ConfirmRow goto="veteranBOS" name="Branch of Service:">
                {{ getData().service.bos.toUpperCase()}}                    
              </ConfirmRow>
              <ConfirmRow goto="veteranBOS" name="Start Date:">
                {{ epochToDate(getData().service.startDate)}}                    
              </ConfirmRow>
              <ConfirmRow goto="veteranBOS" name="End Date:">
                {{ epochToDate(getData().service.endDate)}}                    
              </ConfirmRow>
              <ConfirmRow goto="veteranBOS" name="Discharge Type:">
                {{ getData().service.dischargeType.toUpperCase()}}                    
              </ConfirmRow>
              <ConfirmRow goto="veteranBOS" name="Notes:">
                {{ getData().service.notes}}                    
              </ConfirmRow>                                                                                          
            </tbody>
          </table>
        </div>
        <div class="card-footer">
       
          <button type="submit" class="btn btn-primary btn-block">
              <span v-show="submitting" class="spinner-border spinner-border-sm" role="status" aria-hidden="false"></span>   
              Submit</button>
        </div>
      </div>
      <br>
      <div class="btn-group container" role="group">
        <button type="button" v-on:click="onPrev()" class="btn btn-secondary">&lt; Back</button>
      </div>
    </form>
  </div>
</template>

<style>
  tr {
    cursor: pointer;
  }
</style>

<script>
import ConfirmRow from './ConfirmRow.vue'
import moment from 'moment'

export default {
  name: "Submit",
  components: {
    ConfirmRow
  },
  created: function() {},

  methods: {
    onPrev: function() {
      this.$parent.$emit("setCurrentQuestion", "claimantSignature");
    },
    isVisible: function() {
      return this.$parent.currentQuestion === "submit";
    },
    showFeeAgreement: function() {
      let url = new URL(window.location.href);
      return url.searchParams.get("firmId") === '1';
    },
    // example showKey: claimantSignature from App.vue
    getAnswer(showKey) {
      let found = this.$parent.$children.find(child => {
        return child.$attrs.show === showKey;
      });
      if (found !== undefined) {
        return found.$data;
      } else {
        return undefined;
      }
    },
    dateToEpoch(dateString) {
      let date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return 0;
      } else {
        return moment(dateString).unix()*1000;
      }
    },
    epochToDate(epoch) {
      if (epoch !== 0) {
        return moment.utc(epoch).format('MM-DD-YYYY');
      } else {
        return "";
      }
    },
    booleanToYN(bool) {
      return bool ? "Yes" : "No"
    },
    getPerson(personType) {

      let name = this.getAnswer(personType + "Name");
      let birthday = this.getAnswer(personType + "BirthDay");
      let ssn = this.getAnswer(personType + "SSN");
      if (ssn) {
        ssn = ssn.firstThree + ssn.middleTwo + ssn.lastFour;
      }
      let vaFileNumber = this.getAnswer(personType + "SSN")
        .vaFileNumber;
      let sex = this.getAnswer(personType + "Sex").sex;
      let email = this.getAnswer(personType + "Email");
      let emergencyContact = this.getAnswer(personType + "EmergencyContact");

      let address = this.getAnswer(personType+"Address");

      let deathDay = this.getAnswer(personType+"DeathDay");

      if (deathDay === undefined) {
        deathDay = 0;
      } else {
        deathDay = this.dateToEpoch(deathDay.deathDay);
      }

      return {
        id: 0,
        firstName: name.first,
        middleName: name.middle,
        lastName: name.last,
        birthDay: this.dateToEpoch(birthday.birthday),
        placeOfBirth: birthday.placeOfBirth,
        deathDay: deathDay,
        SSN: ssn,
        vaFileNumber: vaFileNumber,
        sex: sex,
        phoneNumber: email.phoneNumber,
        cellPhoneNumber: email.cellPhoneNumber,
        callFrequency: 0,
        email: email.email,
        emergencyContactName: emergencyContact.emergencyContactName,
        emergencyContactPhone: emergencyContact.emergencyContactPhone,
        emergencyContactAddress: emergencyContact.emergencyContactAddress,
        street: address.street,
        unit: address.unit,
        city: address.city,
        state: address.state,
        zipCode: address.zipCode
      };
    },
    veteranRelationship: function() {
      return this.$parent.$data.veteranRelationship;
    },
    getData: function() {
      var data = {};
      var veteranRelationship = this.veteranRelationship();

      data["claimant"] = {
        id: 0,
        personId: 0,
        caseId: 0,
        person: this.getPerson("claimant"),
        veteranRelationship: veteranRelationship
      };

      var veteranPerson = null;
      if (veteranRelationship !== "Self") {
        veteranPerson = this.getPerson("veteran");
      }

      data["veteran"] = {};
      data["veteran"]["id"] = 0;
      data["veteran"]["person"] = veteranPerson;
      data["veteran"]["caseId"] = 0;
      data["veteran"]["personId"] = 0;
      data["veteran"]["PEBDisability"] = 0;
      data["veteran"]["currentAnnualIncome"] = 0;
      data["veteran"]["currentVADisability"] = Number(
        data["veteran"]["currentVADisability"]
      );
      data["veteran"]["eligbleForVAPension"] = false;
      data["veteran"]["eligbleForVAPensionInfoRequested"] = false;
      data["veteran"]["NSC"] = false;
      data["veteran"]["NSCInfoRequested"] = false;

      data["service"] = Object.assign({}, this.getAnswer("veteranBOS"));
      data["service"]["startDate"] = this.dateToEpoch(
        data["service"]["startDate"]
      );
      data["service"]["endDate"] = this.dateToEpoch(data["service"]["endDate"]);

      data["service"]["veteranId"] = 0;
      data["service"]["id"] = 0;

      data["signature"] = document.getElementById("signature").toDataURL();

      data["code"] = this.$parent.code;

      return data;
    },
    submit: function() {
      var data = this.getData();
      let http = new XMLHttpRequest();

      let url;
      if (this.$parent.$data.dev === true) {
        // eslint-disable-next-line
        console.warn("Intake Form development mode is on");
        url = "http://localhost:8080/intake";
      } else {
        url = `../../../vch/intake`;
      }
      http.open("POST", url, true);

      http.withCredentials = true;
      http.setRequestHeader("Content-Type", "application/json");

      this.submitting = true;
      var _this = this;
      http.onload = function() {
        if (_this.$parent.$data.dev === false) {
          _this.$parent.$data.complete = true;
        }
      };      

      http.send(JSON.stringify(data));
    }
  },

  data: function() {
    return {
      nextDisabled: true,
      submitting: false,
    };
  }
};
</script>